import React, { useEffect, useState } from "react";
import { Header, Menu, Segment } from "semantic-ui-react";
import Alerts from "utilities/Alerts";
import http from "utilities/http";
import InventoryAccordion from "../features/InventoryAccordion";

function Inventory() {
	const [inventories, setInventories] = useState([]);

	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setLoading(true);
		http.get("/report/inventory/current")
			.then((response) => {
				const { inventory } = response.data;

				setInventories(inventory);
			})
			.catch((ex) => Alerts.httpException(ex))
			.finally(() => setLoading(false));
	}, [setLoading]);

	return (
		<>
			<Menu
				borderless
				style={{ position: "sticky", top: "0px", zIndex: "99" }}
			>
				<Menu.Item>
					<Header as="h3" content="Inventory" />
				</Menu.Item>
			</Menu>
			<Segment basic loading={loading}>
				<InventoryAccordion inventories={inventories} />
			</Segment>
		</>
	);
}

export default Inventory;
